// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6973412c","232":"2ca44085","237":"efb65891","526":"d42f24d7"}[chunkId] + ".chunk.js";
};